/** Browser fallback: retain a complete backup before replacing a directory. */
export async function copyDirectory(
  source: FileSystemDirectoryHandle,
  target: FileSystemDirectoryHandle
): Promise<void> {
  for await (const [name, entry] of source.entries()) {
    if (entry.kind === 'directory') {
      await copyDirectory(
        entry as FileSystemDirectoryHandle,
        await target.getDirectoryHandle(name, { create: true })
      );
    } else {
      const file = await (entry as FileSystemFileHandle).getFile();
      const handle = await target.getFileHandle(name, { create: true });
      const writable = await handle.createWritable();
      try {
        await writable.write(file);
        await writable.close();
      } catch (error) {
        await writable.abort().catch(() => undefined);
        throw error;
      }
    }
  }
}
